import { call, put, select } from "redux-saga/effects";
import api from "../../services/api";
import { Creators as PropostasActions } from "../ducks/propostas";
import { Creators as PropostasAlertasActions } from "../ducks/propostasAlertas";
import { Creators as PropostasStoresActions } from "../ducks/PageStores/propostasStores";
import { Creators as ModalCadastroPropostasActions } from "../ducks/modalCadastroPropostas";
import { Creators as ModalEdicaoPropostasActions } from "../ducks/modalEdicaoPropostas";
import { Creators as ModalDocsActions } from "../ducks/modalDocs";
import { Creators as ModalStatusActions } from "../ducks/modalStatus";
import { Creators as ModalComissionsActions } from "../ducks/modalComissions";
import { Creators as ModalRateActions } from "../ducks/modalRate";
import { Creators as ModalPrint } from "../ducks/modalPrint";
import { Creators as AlertActions } from "../ducks/alert";
import { Creators as ErrorActions } from "../ducks/error";
import { Creators as SuccessActions } from "../ducks/success";
import { Creators as LoadingActions } from "../ducks/loading";
import moment from "moment";
import { formatReal, formatSize, formatPercent } from "../../helpers";

export function* getListPropostas() {
  try {
    yield put(LoadingActions.setLoading());
    const { page, rowsPerPage, filter } = yield select(
      (state) => state.propostas
    );
    const { data: type, started_at, finished_at } = yield select(
      (state) => state.filtrosPropostas
    );
    if (filter.date_filter) {
      filter.date_filter = {
        type:
          type.split("-", 1)[0] === "1"
            ? "sale"
            : type.split("-", 1)[0] === "2"
            ? "accepted"
            : type.split("-", 1)[0] === "3"
            ? "paid"
            : type.split("-", 1)[0] === "4"
            ? "canceled"
            : type.split("-", 1)[0] === "5"
            ? "portability_date_paid"
            : type.split("-", 1)[0] === "6"
            ? "conclusion_date"
            : type.split("-", 1)[0] === "7"
            ? "type_bank"
            : null,
        started_at: moment(started_at).format("DD/MM/YYYY"),
        finished_at: moment(finished_at).format("DD/MM/YYYY"),
      };
    }
    const { actionProposta } = yield select((state) => state.propostasStores);
    if (actionProposta === "EXPORT") {
      filter.export = true;
    }
    const { data } = yield call(
      api.post,
      `/sales/filtered?page=${page + 1}&&per_page=${rowsPerPage}`,
      filter
    );
    const { data: propostas, total, columns } = data;
    /* GERAÇÃO DAS PROPOSTAS, MELHORAR ISSO UTILIZANDO DRY */
    let propostasPayload = [];
    let idOfColumns = columns
      .filter((column) => column.active === true || column.active === "true")
      .map((column) => column.id);
    const total_financed = idOfColumns.includes("value_financed")
      ? formatReal(
          propostas.reduce((total, current) => {
            if (current.sum_values === 1) {
              return total + current.value_financed;
            } else {
              return total + 0;
            }
          }, 0)
        )
      : "";
    const total_debit = idOfColumns.includes("value_debit")
      ? formatReal(
          propostas.reduce((total, current) => {
            if (current.sum_values === 1) {
              return total + current.value_debit;
            } else {
              return total + 0;
            }
          }, 0)
        )
      : "";
    const total_released = idOfColumns.includes("value_released")
      ? formatReal(
          propostas.reduce((total, current) => {
            if (current.sum_values === 1) {
              return total + current.value_released;
            } else {
              return total + 0;
            }
          }, 0)
        )
      : "";
    const total_base = idOfColumns.includes("value_base_total")
      ? formatReal(
          propostas.reduce((total, current) => {
            if (current.sum_values === 1) {
              return total + current.value_base_total;
            } else {
              return total + 0;
            }
          }, 0)
        )
      : "";
    const total_mutiplier = idOfColumns.includes("value_multiplier")
      ? formatReal(
          propostas.reduce((total, current) => {
            if (current.sum_values === 1) {
              return total + current.value_multiplier;
            } else {
              return total + 0;
            }
          }, 0)
        )
      : "";
    const total_receipted_total = idOfColumns.includes("total_receipted")
      ? formatReal(
          propostas.reduce((total, current) => {
            if (current.sum_values === 1) {
              return total + current.total_receipted;
            } else {
              return total + 0;
            }
          }, 0)
        )
      : "";
    const total_estornado_total = idOfColumns.includes("total_estornado")
      ? formatReal(
          propostas.reduce((total, current) => {
            if (current.sum_values === 1) {
              return total + current.total_estornado;
            } else {
              return total + 0;
            }
          }, 0)
        )
      : "";
    const total_comissioned_total = idOfColumns.includes("total_comissioned")
      ? formatReal(
          propostas.reduce((total, current) => {
            if (current.sum_values === 1) {
              return total + current.total_comissioned;
            } else {
              return total + 0;
            }
          }, 0)
        )
      : "";
    const total_value_installment = idOfColumns.includes("value_installment")
      ? formatReal(
          propostas.reduce((total, current) => {
            if (current.sum_values === 1) {
              return total + current.value_installment;
            } else {
              return total + 0;
            }
          }, 0)
        )
      : "";
    const total_receipt_predict = idOfColumns.includes("receipt_predict")
      ? formatReal(
          propostas.reduce((total, current) => {
            if (current.sum_values === 1) {
              return total + current.receipt_predict;
            } else {
              return total + 0;
            }
          }, 0)
        )
      : "";
    let total_comissions_predict = 0;
    propostasPayload = propostas.map((proposta) => ({
      id: proposta.id,
      benefit_number: proposta.benefit_number || "",
      breed: proposta.benefit_breed || "",
      created_at: proposta.created_at
        ? `<span class="data-hora">${moment(proposta.created_at).format(
            "DD/MM/YYYY"
          )} <small class="time-hour">${moment(proposta.created_at).format(
            "H:mm"
          )}</small></span>`
        : "",
      date: proposta.date ? moment(proposta.date).format("DD/MM/YYYY") : "",
      accepted_at: proposta.accepted_at
        ? moment(proposta.accepted_at).format("DD/MM/YYYY")
        : "",
      date_paid: proposta.date_paid
        ? moment(proposta.date_paid).format("DD/MM/YYYY")
        : "",
      portability_date_paid: proposta.portability_date_paid
        ? moment(proposta.portability_date_paid).format("DD/MM/YYYY")
        : "",
      date_canceled: proposta.date_canceled
        ? moment(proposta.date_canceled).format("DD/MM/YYYY")
        : "",
      conclusion_date: proposta.conclusion_date
        ? moment(proposta.conclusion_date).format("DD/MM/YYYY")
        : "",
      user: proposta.user_name || "",
      participating_user: proposta.participating_user_name || "",
      store: proposta.store_name || "",
      bank: proposta.bank_name || "",
      promoter: proposta.promoter_name || "",
      product: proposta.product_name || "",
      operation: proposta.operation_name || "",
      convenet: proposta.convenet_name || "",
      contract_number: proposta.contract_number || "",
      sale_number: proposta.sale_number || "",
      customer: proposta.customer_name
        ? `<span>${
            proposta.customer_dead
              ? '<img src="data:image/svg+xml;base64,&#13;&#10;PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii03NiAwIDUxMiA1MTIiIHdpZHRoPSI1MTIiIGhlaWdodD0iNTEyIiBjbGFzcz0iIj48Zz48cGF0aCBkPSJtMjI1IDUxMnYtMzAxaDEzNXYtOTBoLTEzNXYtMTIxaC05MHYxMjFoLTEzNXY5MGgxMzV2MzAxem0wIDAiIGRhdGEtb3JpZ2luYWw9IiMwMDAwMDAiIGNsYXNzPSJhY3RpdmUtcGF0aCIgc3R5bGU9ImZpbGw6IzQzNDM0MyIgZGF0YS1vbGRfY29sb3I9IiNSR0JBKDAiPjwvcGF0aD48L2c+IDwvc3ZnPg==" title="" style="width: 1.3rem; margin-right: 0.1rem; top: .2rem; position: relative;">'
              : ""
          } ${
            proposta.customer_blacklisted
              ? '<span class="lista-negra"><i class="fa fa-exclamation-circle" style="margin-right: 0.3rem; font-size: 1.5rem; color: #f86c6b; top: .1rem; position: relative;"></i><span class="tag-hover">Este cliente consta na lista negra.</span></span>'
              : ""
          } ${proposta.customer_name} </span>`
        : "",
      customer_cpf: proposta.customer_cpf ? proposta.customer_cpf : "",
      customer_id: proposta.customer_id ? proposta.customer_id : "",
      value_financed: proposta.value_financed
        ? formatReal(proposta.value_financed)
        : "",
      value_debit: proposta.value_debit ? formatReal(proposta.value_debit) : "",
      value_released: proposta.value_released
        ? formatReal(proposta.value_released)
        : "",
      value_base_total: proposta.value_base_total
        ? formatReal(proposta.value_base_total)
        : "",
      comission_percent:
        proposta.value_base_total && proposta.total_receipted
          ? formatPercent(
              (proposta.total_receipted / proposta.value_base_total) * 100
            ).toFixed(2) + " %"
          : "0 %",
      value_multiplier: proposta.value_multiplier
        ? formatReal(proposta.value_multiplier)
        : "",
      total_receipted: proposta.total_receipted
        ? formatReal(proposta.total_receipted)
        : "",
      total_estornado: proposta.total_estornado
        ? formatReal(proposta.total_estornado)
        : "",
      total_comissioned: proposta.total_comissioned
        ? formatReal(proposta.total_comissioned)
        : "",
      receipt_predict: proposta.receipt_predict
        ? formatReal(proposta.receipt_predict)
        : "0,00",
      comissions_predict: proposta.comissions_predict
        ? `
      <span class="timer">
        <span class='tag-child'>
          ${proposta.comissions_predict
            .map(
              (comission) =>
                `<span class="tag-row"><span>${
                  comission.faixa
                }:</span><span>${formatReal(comission.value)}</span></span>`
            )
            .join("")}
        </span>
        ${formatReal(
          proposta.comissions_predict.reduce((total, current) => {
            if (proposta.sum_values === 1) {
              total_comissions_predict =
                total_comissions_predict +
                current.value /
                  (proposta.comissions_predict.length > 1
                    ? proposta.comissions_predict.length
                    : 1);
            }
            return total + current.value;
          }, 0) /
            (proposta.comissions_predict.length > 1
              ? proposta.comissions_predict.length
              : 1)
        )}
      </span>`
        : "",
      deadline: proposta.deadline,
      value_installment: proposta.value_installment
        ? formatReal(proposta.value_installment)
        : "",
      origin: proposta.origin || "",
      status: proposta.status_name
        ? `<span class="td-color" style="color: #ffffff!important; cursor:pointer; background-color:${
            proposta.status_color
          }">
          ${
            proposta.status_notes
              ? `<span class="tag-child">
          <span class="tag-row">${proposta.status_notes}</span>
        </span>`
              : ""
          }
            ${proposta.status_name}
          </span>`
        : "",
      last_status: proposta.sales_status_updated_at
        ? `<span class="lowercase timer">
            <span class='tag-child'>
              <span class='tag-row'>
                Último status por:&nbsp;<b>${proposta.status_user_name}</b>
              </span>
            </span>
            ${moment(
              moment(proposta.sales_status_updated_at).format(
                "DD/MM/YYYY H:mm:ss"
              ),
              "DD/MM/YYYY H:mm:ss"
            ).fromNow()}
        </span>`
        : "",
      last_status_time: proposta.sales_status_updated_at
        ? proposta.sales_status_updated_at
        : "",
      docs:
        proposta.notes && !proposta.docs
          ? `<span class="s-docs docs-not-ok-warning"><span class='tag-child'><span class='tag-row'>Observações: ${
              proposta.notes
            }</span></span>
              ${
                proposta.count_sale_files <= 0 &&
                proposta.count_customer_files <= 0
                  ? '<i class="fa fa-folder-o fa-lg" />'
                  : '<i class="fa fa-folder fa-lg has-files" />'
              }
              </span>`
          : proposta.docs
          ? `<span class="s-docs docs-ok"><span class='tag-child'><span class='tag-row'>Documentação Ok</span></span>${
              proposta.count_sale_files <= 0 &&
              proposta.count_customer_files <= 0
                ? '<i class="fa fa-folder-o fa-lg" />'
                : '<i class="fa fa-folder fa-lg has-files" />'
            }</span>`
          : `<span class="s-docs docs-not-ok">${
              proposta.count_sale_files <= 0 &&
              proposta.count_customer_files <= 0
                ? '<i class="fa fa-folder-o fa-lg" />'
                : '<i class="fa fa-folder fa-lg has-files" />'
            }</span>`,
      sum_values: proposta.sum_values,
      edit_status: proposta.status_adm_change ? proposta.status_adm_change : 0,
      rating: proposta.rating ? proposta.rating.rating : "",
      notes: proposta.rating ? proposta.rating.notes : "",
      bordero:
        proposta.borderos && proposta.borderos.length > 0
          ? `<span class="total-borderos" style="text-align: center; position: relative; width: 2.4rem; height: 2rem; display: flex; align-items: center; justify-content: center; color: #ffffff; background: #613838; border-radius: 5px; font-size: 1rem!important;">${
              proposta.borderos.length
            }
      ${
        proposta.borderos.length > 0
          ? `
        <span class="tag-hover">
          ${proposta.borderos
            .map(
              (bordero) =>
                `<span class="tag-child">
                  Borderô de ${bordero.bank ? "banco" : "remessa"}: ${
                  bordero.code
                }
                </span>`
            )
            .join("")}
        </span>
      `
          : ""
      }
      </span>
      `
          : null,
    }));
    /* GERAÇÃO DAS PROPOSTAS, MELHORAR ISSO UTILIZANDO DRY */
    yield put(
      PropostasActions.getListPropostasSuccess(
        propostasPayload,
        total,
        total_financed,
        total_released,
        total_debit,
        total_base,
        total_mutiplier,
        total_receipted_total,
        total_estornado_total,
        total_comissioned_total,
        total_value_installment,
        total_receipt_predict,
        formatReal(total_comissions_predict),
        columns,
        data.export
      )
    );
    if (filter.search) {
      yield put(PropostasActions.getTotalsPropostasSuccess(0));
      yield put(PropostasActions.getTotalsPropostas());
    }
    if (actionProposta === "EXPORT") {
      window.open(data.export, "_blank");
      yield put(PropostasStoresActions.setAction("LIST"));
    }
  } catch (err) {
    if (err.response.data) {
      if (err.response.data.error) {
        let message = err.response.data.error.message;
        let erros = "";
        if (
          err.response.data.error.errors &&
          err.response.data.error.errors.length > 0
        ) {
          erros = err.response.data.error.errors
            .map((err) => `${err} <br/>`)
            .join("");
        }
        yield put(ErrorActions.openError(`${message}<br/>${erros}`));
      } else {
        yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
      }
    } else {
      yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
    }
  }
  yield put(LoadingActions.unsetLoading());
}

export function* getTotalsPropostas() {
  try {
    let { filter } = yield select((state) => state.propostas);
    const { data: type, started_at, finished_at } = yield select(
      (state) => state.filtrosPropostas
    );
    filter.date_filter = {
      type:
        type.split("-", 1)[0] === "1"
          ? "sale"
          : type.split("-", 1)[0] === "2"
          ? "accepted"
          : type.split("-", 1)[0] === "3"
          ? "paid"
          : type.split("-", 1)[0] === "4"
          ? "canceled"
          : type.split("-", 1)[0] === "5"
          ? "portability_date_paid"
          : type.split("-", 1)[0] === "6"
          ? "conclusion_date"
          : type.split("-", 1)[0] === "7"
          ? "type_bank"
          : null,
      started_at: moment(started_at).format("DD/MM/YYYY"),
      finished_at: moment(finished_at).format("DD/MM/YYYY"),
    };
    if (filter.search) {
      filter = { search: filter.search };
    }
    const { actionProposta } = yield select((state) => state.propostasStores);
    if (actionProposta === "EXPORT") {
      filter.export = true;
    }
    const { data } = yield call(api.post, `/sales/totals-painel`, filter);
    const {
      valid_sales,
      accepted_sales,
      not_accepted_sales,
      canceled_sales,
    } = data;
    /* GERAÇÃO DAS PROPOSTAS, MELHORAR ISSO UTILIZANDO DRY */
    valid_sales.receipted_percent =
      valid_sales.total_receipted > 0 && valid_sales.value_base > 0
        ? formatPercent(
            (valid_sales.total_receipted / valid_sales.value_base) * 100
          ).toFixed(2) + " %"
        : "0 %";
    valid_sales.value_financed = formatReal(valid_sales.value_financed);
    valid_sales.value_released = formatReal(valid_sales.value_released);
    valid_sales.value_base = formatReal(valid_sales.value_base);
    valid_sales.multiplier = formatReal(valid_sales.multiplier);
    valid_sales.receipt_predict = formatReal(valid_sales.receipt_predict);
    valid_sales.total_receipted = formatReal(valid_sales.total_receipted);
    accepted_sales.receipted_percent =
      accepted_sales.total_receipted > 0 && accepted_sales.value_base > 0
        ? formatPercent(
            (accepted_sales.total_receipted / accepted_sales.value_base) * 100
          ).toFixed(2) + " %"
        : "0 %";
    accepted_sales.value_financed = formatReal(accepted_sales.value_financed);
    accepted_sales.value_released = formatReal(accepted_sales.value_released);
    accepted_sales.value_base = formatReal(accepted_sales.value_base);
    accepted_sales.multiplier = formatReal(accepted_sales.multiplier);
    accepted_sales.receipt_predict = formatReal(accepted_sales.receipt_predict);
    accepted_sales.total_receipted = formatReal(accepted_sales.total_receipted);
    not_accepted_sales.receipted_percent =
      not_accepted_sales.total_receipted > 0 &&
      not_accepted_sales.value_base > 0
        ? formatPercent(
            (not_accepted_sales.total_receipted /
              not_accepted_sales.value_base) *
              100
          ).toFixed(2) + " %"
        : "0 %";
    not_accepted_sales.value_financed = formatReal(
      not_accepted_sales.value_financed
    );
    not_accepted_sales.value_released = formatReal(
      not_accepted_sales.value_released
    );
    not_accepted_sales.value_base = formatReal(not_accepted_sales.value_base);
    not_accepted_sales.multiplier = formatReal(not_accepted_sales.multiplier);
    not_accepted_sales.receipt_predict = formatReal(
      not_accepted_sales.receipt_predict
    );
    not_accepted_sales.total_receipted = formatReal(
      not_accepted_sales.total_receipted
    );
    canceled_sales.receipted_percent =
      canceled_sales.total_receipted > 0 && canceled_sales.value_base > 0
        ? formatPercent(
            (canceled_sales.total_receipted / canceled_sales.value_base) * 100
          ).toFixed(2) + " %"
        : "0 %";
    canceled_sales.value_financed = formatReal(canceled_sales.value_financed);
    canceled_sales.value_released = formatReal(canceled_sales.value_released);
    canceled_sales.value_base = formatReal(canceled_sales.value_base);
    canceled_sales.multiplier = formatReal(canceled_sales.multiplier);
    canceled_sales.receipt_predict = formatReal(canceled_sales.receipt_predict);
    canceled_sales.total_receipted = formatReal(canceled_sales.total_receipted);
    /* GERAÇÃO DAS PROPOSTAS, MELHORAR ISSO UTILIZANDO DRY */
    yield put(
      PropostasActions.getTotalsPropostasSuccess({
        valid_sales,
        accepted_sales,
        not_accepted_sales,
        canceled_sales,
      })
    );
  } catch (err) {
    if (err.response.data) {
      if (err.response.data.error) {
        let message = err.response.data.error.message;
        let erros = "";
        if (
          err.response.data.error.errors &&
          err.response.data.error.errors.length > 0
        ) {
          erros = err.response.data.error.errors
            .map((err) => `${err} <br/>`)
            .join("");
        }
        yield put(ErrorActions.openError(`${message}<br/>${erros}`));
      } else {
        yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
      }
    } else {
      yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
    }
  }
  yield put(LoadingActions.unsetLoading());
}

export function* getPropostas({ payload }) {
  try {
    const { actionProposta } = yield select((state) => state.propostasStores);
    if (actionProposta === "STATUS") {
      yield put(PropostasActions.getPropostaHistory(payload.id));
    } else {
      yield put(LoadingActions.setLoading());
      const { data } = yield call(api.get, `/sales/${payload.id}`);
      if (data.status && data.status.length > 0) {
        data.status = data.status.map((status) => {
          status.updated_at =
            moment(status.updated_at) >= moment(status.date) &&
            (moment(status.date) >= moment() ||
              data.status.reduce((total, current) => {
                if (current.name === status.name) {
                  return (total = total + 1);
                } else {
                  return total;
                }
              }, 0) === 1)
              ? `${moment(status.updated_at).format("dddd")}, ${moment(
                  status.updated_at
                ).format("DD/MM/YYYY")} às ${moment(status.updated_at).format(
                  "LT"
                )}`
              : `${moment(status.date).format("dddd")}, ${moment(
                  status.date
                ).format("DD/MM/YYYY")} às ${moment(status.date).format("LT")}`;
          return status;
        });
      }
      if (data.receipts && data.receipts.length > 0) {
        data.receipts = data.receipts.map((receipt) => {
          receipt.amount = formatReal(receipt.amount);
          receipt.created_at = moment(receipt.current_at).format("DD/MM/YYYY");
          return receipt;
        });
      }
      if (data.comissions && data.comissions.length > 0) {
        data.comissions = data.comissions.map((receipt) => {
          receipt.amount = formatReal(receipt.amount);
          receipt.created_at = moment(receipt.current_at).format("DD/MM/YYYY");
          receipt.destiny =
            receipt.comissionable_type === "stores"
              ? `Loja: ${
                  receipt.comissionable_name ? receipt.comissionable_name : ""
                }`
              : receipt.responsible === 1
              ? `Gerente: ${
                  receipt.comissionable_name ? receipt.comissionable_name : ""
                }`
              : `Vendedor: ${
                  receipt.comissionable_name ? receipt.comissionable_name : ""
                }`;
          return receipt;
        });
      }
      if (data.files && data.files.length > 0) {
        data.files = data.files.map((file) => {
          file.date = file.date ? moment(file.date).format("DD/MM/YYYY") : "";
          file.created_at = file.created_at
            ? moment(file.created_at).format("DD/MM/YYYY HH:mm:ss")
            : "";
          file.user_name = file.user ? file.user.name : "";
          file.size = file.size ? formatSize(file.size) : "";
          return file;
        });
      }
      yield put(PropostasActions.getPropostasSuccess(data));
      if (actionProposta === "EDIT" || actionProposta === "DETAIL") {
        yield put(ModalEdicaoPropostasActions.openModalEdicaoPropostas());
      } else if (actionProposta === "DOCS") {
        yield put(ModalDocsActions.openDocsModal());
      } else if (actionProposta === "PRINT") {
        yield put(PropostasActions.print(data.id));
      } else if (actionProposta === "COMISSIONS") {
        yield put(ModalComissionsActions.openComissionsModal());
      } else if (actionProposta === "RATE") {
        yield put(ModalRateActions.openRateModal());
      } else {
        const title = "Aviso de exclusão";
        const body = `A proposta "${
          data.contract_number ? data.contract_number : data.id
        }" será excluido do sistema.`;
        yield put(AlertActions.openAlert(title, body));
      }
    }
  } catch (err) {
    if (err.response.data) {
      if (err.response.data.error) {
        let message = err.response.data.error.message;
        let erros = "";
        if (
          err.response.data.error.errors &&
          err.response.data.error.errors.length > 0
        ) {
          erros = err.response.data.error.errors
            .map((err) => `${err} <br/>`)
            .join("");
        }
        yield put(ErrorActions.openError(`${message}<br/>${erros}`));
      } else {
        yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
      }
    } else {
      yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
    }
  }
  yield put(LoadingActions.unsetLoading());
}

export function* getDocsPropostas({ payload }) {
  try {
    yield put(LoadingActions.setLoading());
    const { data } = yield call(api.get, `/sales/${payload.id}/docs`);
    if (data.files && data.files.length > 0) {
      data.files = data.files.map((file) => {
        file.date = file.date ? moment(file.date).format("DD/MM/YYYY") : "";
        file.created_at = file.created_at
          ? moment(file.created_at).format("DD/MM/YYYY HH:mm:ss")
          : "";
        file.user_name = file.user ? file.user.name : "";
        file.size = file.size ? formatSize(file.size) : "";
        return file;
      });
    }
    yield put(PropostasActions.getDocsPropostasSuccess(data));
    yield put(ModalDocsActions.openDocsModal());
  } catch (err) {
    if (err.response.data) {
      if (err.response.data.error) {
        let message = err.response.data.error.message;
        let erros = "";
        if (
          err.response.data.error.errors &&
          err.response.data.error.errors.length > 0
        ) {
          erros = err.response.data.error.errors
            .map((err) => `${err} <br/>`)
            .join("");
        }
        yield put(ErrorActions.openError(`${message}<br/>${erros}`));
      } else {
        yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
      }
    } else {
      yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
    }
  }
  yield put(LoadingActions.unsetLoading());
}

export function* editPropostas({ payload }) {
  try {
    yield put(LoadingActions.setLoading());
    yield call(api.put, `/sales/${payload.id}`, payload);
    const { currentPageName } = yield select((state) => state.pages);
    if (currentPageName === "Propostas") {
      yield put(PropostasActions.getListPropostas());
    } else {
      yield put(PropostasAlertasActions.getListPropostasAlertas());
    }
    yield put(ModalEdicaoPropostasActions.closeModalEdicaoPropostas());
    yield put(SuccessActions.openSuccess("Proposta editada com sucesso."));
  } catch (err) {
    if (err.response.data) {
      if (err.response.data.error) {
        let message = err.response.data.error.message;
        let erros = "";
        if (
          err.response.data.error.errors &&
          err.response.data.error.errors.length > 0
        ) {
          erros = err.response.data.error.errors
            .map((err) => `${err} <br/>`)
            .join("");
        }
        yield put(ErrorActions.openError(`${message}<br/>${erros}`));
      } else {
        yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
      }
    } else {
      yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
    }
    yield put(LoadingActions.unsetLoading());
  }
}

export function* addPropostas({ payload }) {
  try {
    yield put(LoadingActions.setLoading());
    yield call(api.post, `/sales`, payload);
    yield put(PropostasActions.searchPropostas({}));
    yield put(PropostasActions.getListPropostas());
    yield put(ModalCadastroPropostasActions.closeModalCadastroPropostas());
    yield put(PropostasStoresActions.setFieldsPropostas({}));
    yield put(SuccessActions.openSuccess("Proposta adicionada com sucesso."));
  } catch (err) {
    if (err.response.data) {
      if (err.response.data.error) {
        let message = err.response.data.error.message;
        let erros = "";
        if (
          err.response.data.error.errors &&
          err.response.data.error.errors.length > 0
        ) {
          erros = err.response.data.error.errors
            .map((err) => `${err} <br/>`)
            .join("");
        }
        yield put(ErrorActions.openError(`${message}<br/>${erros}`));
      } else {
        yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
      }
    } else {
      yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
    }
  }
  yield put(LoadingActions.unsetLoading());
}

export function* deletePropostas() {
  try {
    yield put(LoadingActions.setLoading());
    const { id } = yield select((state) => state.propostas.item);
    yield call(api.delete, `/sales/${id}`);
    const { currentPageName } = yield select((state) => state.pages);
    if (currentPageName === "Propostas") {
      yield put(PropostasActions.getListPropostas());
    } else {
      yield put(PropostasAlertasActions.getListPropostasAlertas());
    }
    yield put(SuccessActions.openSuccess("Proposta excluída com sucesso."));
  } catch (err) {
    if (err.response.data) {
      if (err.response.data.error) {
        let message = err.response.data.error.message;
        let erros = "";
        if (
          err.response.data.error.errors &&
          err.response.data.error.errors.length > 0
        ) {
          erros = err.response.data.error.errors
            .map((err) => `${err} <br/>`)
            .join("");
        }
        yield put(ErrorActions.openError(`${message}<br/>${erros}`));
      } else {
        yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
      }
    } else {
      yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
    }
  }
  yield put(AlertActions.closeAlert());
  yield put(LoadingActions.unsetLoading());
}

export function* searchPropostas() {
  try {
    yield put(PropostasActions.getListPropostas());
  } catch (err) {
    if (err.response.data) {
      if (err.response.data.error) {
        let message = err.response.data.error.message;
        let erros = "";
        if (
          err.response.data.error.errors &&
          err.response.data.error.errors.length > 0
        ) {
          erros = err.response.data.error.errors
            .map((err) => `${err} <br/>`)
            .join("");
        }
        yield put(ErrorActions.openError(`${message}<br/>${erros}`));
      } else {
        yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
      }
    } else {
      yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
    }
  }
}

export function* getListPropostasSelects() {
  try {
    const { data: propostas } = yield call(api.get, `/sales/select`);
    yield put(PropostasActions.getListPropostasSuccessSelects(propostas));
  } catch (err) {
    if (err.response.data) {
      if (err.response.data.error) {
        let message = err.response.data.error.message;
        let erros = "";
        if (
          err.response.data.error.errors &&
          err.response.data.error.errors.length > 0
        ) {
          erros = err.response.data.error.errors
            .map((err) => `${err} <br/>`)
            .join("");
        }
        yield put(ErrorActions.openError(`${message}<br/>${erros}`));
      } else {
        yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
      }
    } else {
      yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
    }
  }
}

export function* print({ payload }) {
  try {
    const { data: url } = yield call(api.get, `/sales/${payload.id}/pdf`);
    yield put(PropostasActions.printSuccess(url.pdf));
    yield put(ModalPrint.openPrintModal());
  } catch (err) {
    if (err.response.data) {
      if (err.response.data.error) {
        let message = err.response.data.error.message;
        let erros = "";
        if (
          err.response.data.error.errors &&
          err.response.data.error.errors.length > 0
        ) {
          erros = err.response.data.error.errors
            .map((err) => `${err} <br/>`)
            .join("");
        }
        yield put(ErrorActions.openError(`${message}<br/>${erros}`));
      } else {
        yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
      }
    } else {
      yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
    }
  }
}

export function* checkColumn({ payload }) {
  try {
    const config = payload.settings;
    const { data: columns } = yield call(api.patch, `/sales/setting/list`, {
      config,
      new: true,
    });
    yield put(PropostasActions.checkColumnSuccess(columns.config));
  } catch (err) {
    if (err.response.data) {
      if (err.response.data.error) {
        let message = err.response.data.error.message;
        let erros = "";
        if (
          err.response.data.error.errors &&
          err.response.data.error.errors.length > 0
        ) {
          erros = err.response.data.error.errors
            .map((err) => `${err} <br/>`)
            .join("");
        }
        yield put(ErrorActions.openError(`${message}<br/>${erros}`));
      } else {
        yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
      }
    } else {
      yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
    }
  }
}

export function* deleteAllPropostas({ payload }) {
  try {
    yield put(LoadingActions.setLoading());
    yield call(api.post, `/sales/destroy-many`, {
      sales_id: payload.selected,
    });
    yield put(PropostasActions.getListPropostas());
    yield put(SuccessActions.openSuccess("Cadastros excluídos com sucesso."));
  } catch (err) {
    if (err.response.data) {
      if (err.response.data.error) {
        let message = err.response.data.error.message;
        let erros = "";
        if (
          err.response.data.error.errors &&
          err.response.data.error.errors.length > 0
        ) {
          erros = err.response.data.error.errors
            .map((err) => `${err} <br/>`)
            .join("");
        }
        yield put(ErrorActions.openError(`${message}<br/>${erros}`));
      } else {
        yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
      }
    } else {
      yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
    }
  }
  yield put(AlertActions.closeAlert());
  yield put(LoadingActions.unsetLoading());
}

export function* ratePropostas({ payload }) {
  try {
    yield put(LoadingActions.setLoading());
    yield call(api.patch, `/sales/${payload.id}/rating`, payload);
    yield put(PropostasActions.getListPropostas());
    yield put(ModalRateActions.closeRateModal());
    yield put(SuccessActions.openSuccess("Proposta avaliada com sucesso."));
  } catch (err) {
    if (err.response.data) {
      if (err.response.data.error) {
        let message = err.response.data.error.message;
        let erros = "";
        if (
          err.response.data.error.errors &&
          err.response.data.error.errors.length > 0
        ) {
          erros = err.response.data.error.errors
            .map((err) => `${err} <br/>`)
            .join("");
        }
        yield put(ErrorActions.openError(`${message}<br/>${erros}`));
      } else {
        yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
      }
    } else {
      yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
    }
    yield put(LoadingActions.unsetLoading());
  }
}

export function* getPropostaHistory({ payload }) {
  try {
    yield put(LoadingActions.setLoading());
    const { data } = yield call(api.get, `/sales/${payload.id}/history`);
    data.history = data.history.map((history) => {
      history.updated_at = `${moment(history.updated_at).format(
        "dddd"
      )}, ${moment(history.updated_at).format("DD/MM/YYYY")} às ${moment(
        history.updated_at
      ).format("LT")}`;
      return history;
    });
    yield put(PropostasActions.getPropostaHistorySuccess(data));
    yield put(ModalStatusActions.openStatusModal());
  } catch (err) {
    if (err.response.data) {
      if (err.response.data.error) {
        let message = err.response.data.error.message;
        let erros = "";
        if (
          err.response.data.error.errors &&
          err.response.data.error.errors.length > 0
        ) {
          erros = err.response.data.error.errors
            .map((err) => `${err} <br/>`)
            .join("");
        }
        yield put(ErrorActions.openError(`${message}<br/>${erros}`));
      } else {
        yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
      }
    } else {
      yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
    }
  }
  yield put(LoadingActions.unsetLoading());
}

export function* getPropostasRelatorio() {
  try {
    const { reportFilter: filter } = yield select((state) => state.propostas);
    yield put(LoadingActions.setLoading());
    const { actionProposta } = yield select((state) => state.propostasStores);
    if (actionProposta === "EXPORT") {
      filter.export = true;
    }
    const { data } = yield call(api.post, "/sales/filtered", filter);
    const { data: propostas, columns, export: excelExport } = data;
    const total = propostas.length;
    /* GERAÇÃO DAS PROPOSTAS, MELHORAR ISSO UTILIZANDO DRY */
    let idOfColumns = columns
      .filter((column) => column.active === true || column.active === "true")
      .map((column) => column.id);
    const total_goal_production =
      filter.report === "metas"
        ? formatReal(
            propostas.reduce((total, current) => {
              if (current.sum_values === 1) {
                return total + current.goal_production;
              } else {
                return total + 0;
              }
            }, 0)
          )
        : 0;
    const total_financed = idOfColumns.includes("value_financed")
      ? formatReal(
          propostas.reduce((total, current) => {
            if (current.sum_values === 1) {
              return total + current.value_financed;
            } else {
              return total + 0;
            }
          }, 0)
        )
      : "";
    const total_debit = idOfColumns.includes("value_debit")
      ? formatReal(
          propostas.reduce((total, current) => {
            if (current.sum_values === 1) {
              return total + current.value_debit;
            } else {
              return total + 0;
            }
          }, 0)
        )
      : "";
    const total_released = idOfColumns.includes("value_released")
      ? formatReal(
          propostas.reduce((total, current) => {
            if (current.sum_values === 1) {
              return total + current.value_released;
            } else {
              return total + 0;
            }
          }, 0)
        )
      : "";
    const total_base = idOfColumns.includes("value_base_total")
      ? formatReal(
          propostas.reduce((total, current) => {
            if (current.sum_values === 1) {
              return total + current.value_base_total;
            } else {
              return total + 0;
            }
          }, 0)
        )
      : "";
    const total_mutiplier = idOfColumns.includes("value_multiplier")
      ? formatReal(
          propostas.reduce((total, current) => {
            if (current.sum_values === 1) {
              return total + current.value_multiplier;
            } else {
              return total + 0;
            }
          }, 0)
        )
      : "";
    const total_receipted_total = idOfColumns.includes("total_receipted")
      ? formatReal(
          propostas.reduce((total, current) => {
            if (current.sum_values === 1) {
              return total + current.total_receipted;
            } else {
              return total + 0;
            }
          }, 0)
        )
      : "";
    const total_estornado_total = idOfColumns.includes("total_estornado")
      ? formatReal(
          propostas.reduce((total, current) => {
            if (current.sum_values === 1) {
              return total + current.total_estornado;
            } else {
              return total + 0;
            }
          }, 0)
        )
      : "";
    const total_comissioned_total = idOfColumns.includes("total_comissioned")
      ? formatReal(
          propostas.reduce((total, current) => {
            if (current.sum_values === 1) {
              return total + current.total_comissioned;
            } else {
              return total + 0;
            }
          }, 0)
        )
      : "";
    const total_value_installment = idOfColumns.includes("value_installment")
      ? formatReal(
          propostas.reduce((total, current) => {
            if (current.sum_values === 1) {
              return total + current.value_installment;
            } else {
              return total + 0;
            }
          }, 0)
        )
      : "";
    const total_receipt_predict = idOfColumns.includes("receipt_predict")
      ? formatReal(
          propostas.reduce((total, current) => {
            if (current.sum_values === 1) {
              return total + current.receipt_predict;
            } else {
              return total + 0;
            }
          }, 0)
        )
      : "";
    let total_comissions_predict = 0;
    const propostasPayload = propostas.map((proposta) => ({
      id: proposta.id,
      benefit_number: proposta.benefit_number || "",
      breed: proposta.benefit_breed || "",
      created_at: proposta.created_at
        ? `<span class="data-hora">${moment(proposta.created_at).format(
            "DD/MM/YYYY"
          )} <small class="time-hour">${moment(proposta.created_at).format(
            "H:mm"
          )}</small></span>`
        : "",
      date: proposta.date ? moment(proposta.date).format("DD/MM/YYYY") : "",
      accepted_at: proposta.accepted_at
        ? moment(proposta.accepted_at).format("DD/MM/YYYY")
        : "",
      date_paid: proposta.date_paid
        ? moment(proposta.date_paid).format("DD/MM/YYYY")
        : "",
      portability_date_paid: proposta.portability_date_paid
        ? moment(proposta.portability_date_paid).format("DD/MM/YYYY")
        : "",
      date_canceled: proposta.date_canceled
        ? moment(proposta.date_canceled).format("DD/MM/YYYY")
        : "",
      conclusion_date: proposta.conclusion_date
        ? moment(proposta.conclusion_date).format("DD/MM/YYYY")
        : "",
      user: proposta.user_name || "",
      participating_user: proposta.participating_user_name || "",
      store: proposta.store_name || "",
      bank: proposta.bank_name || "",
      promoter: proposta.promoter_name || "",
      product: proposta.product_name || "",
      operation: proposta.operation_name || "",
      convenet: proposta.convenet_name || "",
      contract_number: proposta.contract_number || "",
      sale_number: proposta.sale_number || "",
      customer: proposta.customer_name
        ? `<span>${
            proposta.customer_dead
              ? '<img src="data:image/svg+xml;base64,&#13;&#10;PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii03NiAwIDUxMiA1MTIiIHdpZHRoPSI1MTIiIGhlaWdodD0iNTEyIiBjbGFzcz0iIj48Zz48cGF0aCBkPSJtMjI1IDUxMnYtMzAxaDEzNXYtOTBoLTEzNXYtMTIxaC05MHYxMjFoLTEzNXY5MGgxMzV2MzAxem0wIDAiIGRhdGEtb3JpZ2luYWw9IiMwMDAwMDAiIGNsYXNzPSJhY3RpdmUtcGF0aCIgc3R5bGU9ImZpbGw6IzQzNDM0MyIgZGF0YS1vbGRfY29sb3I9IiNSR0JBKDAiPjwvcGF0aD48L2c+IDwvc3ZnPg==" title="" style="width: 1.3rem; margin-right: 0.1rem; top: .2rem; position: relative;">'
              : ""
          } ${
            proposta.customer_blacklisted
              ? '<span class="lista-negra"><i class="fa fa-exclamation-circle" style="margin-right: 0.3rem; font-size: 1.5rem; color: #f86c6b; top: .1rem; position: relative;"></i><span class="tag-hover">Este cliente consta na lista negra.</span></span>'
              : ""
          } ${proposta.customer_name} </span>`
        : "",
      customer_cpf: proposta.customer_cpf ? proposta.customer_cpf : "",
      customer_id: proposta.customer_id ? proposta.customer_id : "",
      goal_production: proposta.goal_production
        ? `${formatReal(proposta.goal_production)} (${proposta.goals_percent}%)`
        : "",
      value_financed: proposta.value_financed
        ? formatReal(proposta.value_financed)
        : "",
      value_debit: proposta.value_debit ? formatReal(proposta.value_debit) : "",
      value_released: proposta.value_released
        ? formatReal(proposta.value_released)
        : "",
      value_base_total: proposta.value_base_total
        ? formatReal(proposta.value_base_total)
        : "",
      comission_percent:
        proposta.value_base_total && proposta.total_receipted
          ? formatPercent(
              (proposta.total_receipted / proposta.value_base_total) * 100
            ).toFixed(2) + " %"
          : "0 %",
      value_multiplier: proposta.value_multiplier
        ? formatReal(proposta.value_multiplier)
        : "",
      total_receipted: proposta.total_receipted
        ? formatReal(proposta.total_receipted)
        : "",
      total_estornado: proposta.total_estornado
        ? formatReal(proposta.total_estornado)
        : "",
      total_comissioned: proposta.total_comissioned
        ? formatReal(proposta.total_comissioned)
        : "",
      receipt_predict: proposta.receipt_predict
        ? formatReal(proposta.receipt_predict)
        : "0,00",
      comissions_predict: proposta.comissions_predict
        ? `
      <span class="timer">
        <span class='tag-child'>
          ${proposta.comissions_predict
            .map(
              (comission) =>
                `<span class="tag-row"><span>${
                  comission.faixa
                }:</span><span>${formatReal(comission.value)}</span></span>`
            )
            .join("")}
        </span>
        ${formatReal(
          proposta.comissions_predict.reduce((total, current) => {
            if (proposta.sum_values === 1) {
              total_comissions_predict =
                total_comissions_predict +
                current.value /
                  (proposta.comissions_predict.length > 1
                    ? proposta.comissions_predict.length
                    : 1);
            }
            return total + current.value;
          }, 0) /
            (proposta.comissions_predict.length > 1
              ? proposta.comissions_predict.length
              : 1)
        )}
      </span>`
        : "",
      deadline: proposta.deadline,
      value_installment: proposta.value_installment
        ? formatReal(proposta.value_installment)
        : "",
      origin: proposta.origin || "",
      status: proposta.status_name
        ? `<span class="td-color" style="color: #ffffff!important; cursor:pointer; background-color:${
            proposta.status_color
          }">
          ${
            proposta.status_notes
              ? `<span class="tag-child">
          <span class="tag-row">${proposta.status_notes}</span>
        </span>`
              : ""
          }
            ${proposta.status_name}
          </span>`
        : "",
      last_status: proposta.sales_status_updated_at
        ? `<span class="lowercase timer">
            <span class='tag-child'>
              <span class='tag-row'>
                Último status por:&nbsp;<b>${proposta.status_user_name}</b>
              </span>
            </span>
            ${moment(
              moment(proposta.sales_status_updated_at).format(
                "DD/MM/YYYY H:mm:ss"
              ),
              "DD/MM/YYYY H:mm:ss"
            ).fromNow()}
        </span>`
        : "",
      last_status_time: proposta.sales_status_updated_at
        ? proposta.sales_status_updated_at
        : "",
      docs:
        proposta.notes && !proposta.docs
          ? `<span class="s-docs docs-not-ok-warning"><span class='tag-child'><span class='tag-row'>Observações: ${
              proposta.notes
            }</span></span>
              ${
                proposta.count_sale_files <= 0 &&
                proposta.count_customer_files <= 0
                  ? '<i class="fa fa-folder-o fa-lg" />'
                  : '<i class="fa fa-folder fa-lg has-files" />'
              }
              </span>`
          : proposta.docs
          ? `<span class="s-docs docs-ok"><span class='tag-child'><span class='tag-row'>Documentação Ok</span></span>${
              proposta.count_sale_files <= 0 &&
              proposta.count_customer_files <= 0
                ? '<i class="fa fa-folder-o fa-lg" />'
                : '<i class="fa fa-folder fa-lg has-files" />'
            }</span>`
          : `<span class="s-docs docs-not-ok">${
              proposta.count_sale_files <= 0 &&
              proposta.count_customer_files <= 0
                ? '<i class="fa fa-folder-o fa-lg" />'
                : '<i class="fa fa-folder fa-lg has-files" />'
            }</span>`,
      sum_values: proposta.sum_values,
      edit_status: proposta.status_adm_change ? proposta.status_adm_change : 0,
      rating: proposta.rating ? proposta.rating.rating : "",
      notes: proposta.rating ? proposta.rating.notes : "",
      bordero:
        proposta.borderos && proposta.borderos.length > 0
          ? `<span class="total-borderos" style="text-align: center; position: relative; width: 2.4rem; height: 2rem; display: flex; align-items: center; justify-content: center; color: #ffffff; background: #613838; border-radius: 5px; font-size: 1rem!important;">${
              proposta.borderos.length
            }
      ${
        proposta.borderos.length > 0
          ? `
        <span class="tag-hover">
          ${proposta.borderos
            .map(
              (bordero) =>
                `<span class="tag-child">
                  Borderô de ${bordero.bank ? "banco" : "remessa"}: ${
                  bordero.code
                }
                </span>`
            )
            .join("")}
        </span>
      `
          : ""
      }
      </span>
      `
          : null,
    }));
    total_comissions_predict = formatReal(total_comissions_predict);
    const { data: totalsPainel } = yield call(
      api.post,
      `/sales/totals-painel`,
      filter
    );
    const {
      valid_sales,
      accepted_sales,
      not_accepted_sales,
      canceled_sales,
    } = totalsPainel;
    /* GERAÇÃO DAS PROPOSTAS, MELHORAR ISSO UTILIZANDO DRY */
    valid_sales.receipted_percent =
      valid_sales.total_receipted > 0 && valid_sales.value_base > 0
        ? formatPercent(
            (valid_sales.total_receipted / valid_sales.value_base) * 100
          ).toFixed(2) + " %"
        : "0 %";
    valid_sales.value_financed = formatReal(valid_sales.value_financed);
    valid_sales.value_released = formatReal(valid_sales.value_released);
    valid_sales.value_base = formatReal(valid_sales.value_base);
    valid_sales.multiplier = formatReal(valid_sales.multiplier);
    valid_sales.receipt_predict = formatReal(valid_sales.receipt_predict);
    valid_sales.total_receipted = formatReal(valid_sales.total_receipted);
    accepted_sales.receipted_percent =
      accepted_sales.total_receipted > 0 && accepted_sales.value_base > 0
        ? formatPercent(
            (accepted_sales.total_receipted / accepted_sales.value_base) * 100
          ).toFixed(2) + " %"
        : "0 %";
    accepted_sales.value_financed = formatReal(accepted_sales.value_financed);
    accepted_sales.value_released = formatReal(accepted_sales.value_released);
    accepted_sales.value_base = formatReal(accepted_sales.value_base);
    accepted_sales.multiplier = formatReal(accepted_sales.multiplier);
    accepted_sales.receipt_predict = formatReal(accepted_sales.receipt_predict);
    accepted_sales.total_receipted = formatReal(accepted_sales.total_receipted);
    not_accepted_sales.receipted_percent =
      not_accepted_sales.total_receipted > 0 &&
      not_accepted_sales.value_base > 0
        ? formatPercent(
            (not_accepted_sales.total_receipted /
              not_accepted_sales.value_base) *
              100
          ).toFixed(2) + " %"
        : "0 %";
    not_accepted_sales.value_financed = formatReal(
      not_accepted_sales.value_financed
    );
    not_accepted_sales.value_released = formatReal(
      not_accepted_sales.value_released
    );
    not_accepted_sales.value_base = formatReal(not_accepted_sales.value_base);
    not_accepted_sales.multiplier = formatReal(not_accepted_sales.multiplier);
    not_accepted_sales.receipt_predict = formatReal(
      not_accepted_sales.receipt_predict
    );
    not_accepted_sales.total_receipted = formatReal(
      not_accepted_sales.total_receipted
    );
    canceled_sales.receipted_percent =
      canceled_sales.total_receipted > 0 && canceled_sales.value_base > 0
        ? formatPercent(
            (canceled_sales.total_receipted / canceled_sales.value_base) * 100
          ).toFixed(2) + " %"
        : "0 %";
    canceled_sales.value_financed = formatReal(canceled_sales.value_financed);
    canceled_sales.value_released = formatReal(canceled_sales.value_released);
    canceled_sales.value_base = formatReal(canceled_sales.value_base);
    canceled_sales.multiplier = formatReal(canceled_sales.multiplier);
    canceled_sales.receipt_predict = formatReal(canceled_sales.receipt_predict);
    canceled_sales.total_receipted = formatReal(canceled_sales.total_receipted);
    const totals = {
      valid_sales,
      accepted_sales,
      not_accepted_sales,
      canceled_sales,
    };
    yield put(
      PropostasActions.getPropostasRelatorioSuccess({
        data: propostasPayload,
        total,
        total_financed,
        total_released,
        total_debit,
        total_base,
        total_mutiplier,
        total_receipted_total,
        total_estornado_total,
        total_comissioned_total,
        total_value_installment,
        total_receipt_predict,
        total_comissions_predict,
        total_goal_production,
        columns,
        excelExport,
        totals,
      })
    );
    if (actionProposta === "EXPORT") {
      window.open(data.export, "_blank");
      yield put(PropostasStoresActions.setAction("LIST"));
    }
  } catch (err) {
    if (err.response.data) {
      if (err.response.data.error) {
        let message = err.response.data.error.message;
        let erros = "";
        if (
          err.response.data.error.errors &&
          err.response.data.error.errors.length > 0
        ) {
          erros = err.response.data.error.errors
            .map((err) => `${err} <br/>`)
            .join("");
        }
        yield put(ErrorActions.openError(`${message}<br/>${erros}`));
      } else {
        yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
      }
    } else {
      yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
    }
  }
  yield put(LoadingActions.unsetLoading());
}



// WEBPACK FOOTER //
// ./src/store/sagas/propostas.js